import { toPng } from 'html-to-image';

export interface ExportOptions {
  backgroundColor?: string;
  pixelRatio?: number;
  filter?: (node: HTMLElement) => boolean;
}

const defaultFilter = (node: HTMLElement): boolean => {
  if (node.classList && node.classList.contains('no-export')) {
    return false;
  }
  if (node.tagName && (node.tagName === 'SCRIPT' || node.tagName === 'STYLE')) {
    return false;
  }
  return true;
};

export const captureElementAsPng = async (
  element: HTMLElement,
  options: ExportOptions = {}
): Promise<string> => {
  const defaultOptions: ExportOptions = {
    backgroundColor: '#131825',
    pixelRatio: 2,
    filter: defaultFilter,
  };

  const mergedOptions = { ...defaultOptions, ...options };

  try {
    return await toPng(element, mergedOptions);
  } catch (error) {
    console.error('Error capturing element as PNG:', error);
    
    const fallbackOptions = {
      ...mergedOptions,
      pixelRatio: 1,
    };
    
    return await toPng(element, fallbackOptions);
  }
};

export const getDashboardElement = (): HTMLElement | null => {
  return document.getElementById('dashboard-content');
};

export const generateFileName = (
  projectName: string | undefined,
  dashboardName: string,
  extension: string
): string => {
  const sanitizedProjectName = (projectName || 'unknown_project')
    .replace(/[^a-zA-Z0-9-_.]/g, '_')
    .replace(/_+/g, '_')
    .toLowerCase();
  const sanitizedDashboard = dashboardName.toLowerCase();
  
  return `${sanitizedProjectName}_dashboard_${sanitizedDashboard}.${extension}`;
};

export const downloadFile = (dataUrl: string, filename: string): void => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = dataUrl;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};